import bc1 from '../assets/thumbnails/bc1.png';
import bc2 from '../assets/thumbnails/bc2.png';
import bc3 from '../assets/thumbnails/bc3.png';
import bc4 from '../assets/thumbnails/bc4.png';
import bc5 from '../assets/thumbnails/bc5.png';
import bc6 from '../assets/thumbnails/bc6.png';
import bc7 from '../assets/thumbnails/bc7.png';
import bc8 from '../assets/thumbnails/bc8.png';
import bc9 from '../assets/thumbnails/bc9.png';
import bc10 from '../assets/thumbnails/bc10.png';
import bc11 from '../assets/thumbnails/bc11.png';
import bc12 from '../assets/thumbnails/bc12.png';
import bc13 from '../assets/thumbnails/bc13.png';
import bc14 from '../assets/thumbnails/bc14.png';
import bc15 from '../assets/thumbnails/bc15.png';
import bc16 from '../assets/thumbnails/bc16.png';
import bc17 from '../assets/thumbnails/bc17.png';
import bc18 from '../assets/thumbnails/bc18.png';
import bc19 from '../assets/thumbnails/bc19.png';
import bc20 from '../assets/thumbnails/bc20.png';
import bc21 from '../assets/thumbnails/bc21.png';
import bc22 from '../assets/thumbnails/bc22.png';
import bc23 from '../assets/thumbnails/bc23.png';
import bc24 from '../assets/thumbnails/bc24.png';
import bc25 from '../assets/thumbnails/bc25.png';
import bc26 from '../assets/thumbnails/bc26.png';
import bc27 from '../assets/thumbnails/bc27.png';
import bc28 from '../assets/thumbnails/bc28.png';
import bc29 from '../assets/thumbnails/bc29.png';
import bc30 from '../assets/thumbnails/bc30.png';
import bc31 from '../assets/thumbnails/bc31.png';
import bc32 from '../assets/thumbnails/bc32.png';
import bc33 from '../assets/thumbnails/bc33.png';
import bc34 from '../assets/thumbnails/bc34.png';
import bc35 from '../assets/thumbnails/bc35.png';
import bc36 from '../assets/thumbnails/bc36.png';
import bc37 from '../assets/thumbnails/bc37.png';
import bc38 from '../assets/thumbnails/bc38.png';
import bc39 from '../assets/thumbnails/bc39.png';
import bc40 from '../assets/thumbnails/bc40.png';
import bc41 from '../assets/thumbnails/bc41.png';
import bc42 from '../assets/thumbnails/bc42.png';
import bc43 from '../assets/thumbnails/bc43.png';
import bc44 from '../assets/thumbnails/bc44.png';
import bc45 from '../assets/thumbnails/bc45.png';
import bc46 from '../assets/thumbnails/bc46.png';
import bc47 from '../assets/thumbnails/bc47.png';
import bc48 from '../assets/thumbnails/bc48.png';
import bc49 from '../assets/thumbnails/bc49.png';
import bc50 from '../assets/thumbnails/bc50.png';
import bc51 from '../assets/thumbnails/bc51.png';
import bc52 from '../assets/thumbnails/bc52.png';
import bc53 from '../assets/thumbnails/bc53.png';
import bc54 from '../assets/thumbnails/bc54.png';
import bc55 from '../assets/thumbnails/bc55.png';
import bc56 from '../assets/thumbnails/bc56.png';
import bc57 from '../assets/thumbnails/bc57.png';
import bc58 from '../assets/thumbnails/bc58.png';
import bc59 from '../assets/thumbnails/bc59.png';
import bc60 from '../assets/thumbnails/bc60.png';

import Designchip from '../components/Chips/Designchip';
import Devchip from '../components/Chips/Devchip';
import FigmaLogo from '../components/Chips/FigmaLogo';
import Firebase from '../components/Chips/Firebase';
import Illustrator from '../components/Chips/Illustrator';
import Javascript from '../components/Chips/Javascript';
import Mongodb from '../components/Chips/Mongodb';
import Redux from '../components/Chips/Redux';
import Rjs from '../components/Chips/Rjs';
import PalleteLogo from '../components/Chips/PalleteLogo';

// const portfolioData = [
//     {
//     id: 1,
//     title: "Bloome Web Page",
//     image: bc1,
//     description:"Professional user experience design that makes your product intuitive and engaging. I cover everything.",
//     link: "https://dhanushgopi.github.io/bloomelandingpage/",
//     category: "webdev",
//     stack:[<FigmaLogo/>,<Rjs/>],
//     chip: <Devchip/>,
//     },
//     {
//     id: 2,
//     title: "UX",
//     image: bc1,
//     description:"Professional user experience design that makes your product intuitive and engaging. I cover everything.",
//     link: "https://dhanushgopi.github.io/bloomelandingpage/",
//     category: "uxdesign",
//     stack:[<FigmaLogo/>,<Rjs/>],
//     chip: <Designchip/>,
//     },
//      {
//     id: 3,
//     title: "BD",
//     image: bc1,
//     description:"Professional user experience design that makes your product intuitive and engaging. I cover everything.",
//     link: "https://dhanushgopi.github.io/bloomelandingpage/",
//     category: "branddesign",
//     stack:[<FigmaLogo/>,<Rjs/>],
//     chip: <Designchip/>,
//     },
//     {
//     id: 4,
//     title: "GD",
//     image: bc1,
//     description:"Professional user experience design that makes your product intuitive and engaging. I cover everything.",
//     link: "https://dhanushgopi.github.io/bloomelandingpage/",
//     category: "graphicdesign",
//     stack:[<FigmaLogo/>,<Rjs/>],
//     chip: <Designchip/>,
//     },
//      {
//     id: 5,
//     title: "Best Works",
//     image: bc1,
//     description:"Professional user experience design that makes your product intuitive and engaging. I cover everything.",
//     link: "https://dhanushgopi.github.io/bloomelandingpage/",
//     category: "bestworks",
//     stack:[<FigmaLogo/>,<Rjs/>],
//     chip: <Designchip/>,
//     },
//     {
//     id: 5,
//     title: "Best Works",
//     image: bc1,
//     description:"Professional user experience design that makes your product intuitive and engaging. I cover everything.",
//     link: "https://dhanushgopi.github.io/bloomelandingpage/",
//     category: "bestworks",
//     stack:[<FigmaLogo/>,<Rjs/>],
//     chip: <Designchip/>,
//     },
//     {
//     id: 5,
//     title: "Best Works",
//     image: bc1,
//     description:"Professional user experience design that makes your product intuitive and engaging. I cover everything.",
//     link: "https://dhanushgopi.github.io/bloomelandingpage/",
//     category: "bestworks",
//     stack:[<FigmaLogo/>,<Rjs/>],
//     chip: <Designchip/>,
//     },
//     {
//     id: 5,
//     title: "BD",
//     image: bc1,
//     description:"Professional user experience design that makes your product intuitive and engaging. I cover everything.",
//     link: "https://dhanushgopi.github.io/bloomelandingpage/",
//     category: "branddesign",
//     stack:[<FigmaLogo/>,<Rjs/>],
//     chip: <Designchip/>,
//     }
// ]

// export default portfolioData;


const portfolioData = [
    {
    id: 60,
    title: "Creatives for Zuppa",
    date: "Jan 2026",
    image: bc60,
    description:"Creatives for Zuppa - Task is to create various poster for the Social Media and Mobile UI.",
    link: "https://www.behance.net/gallery/243791711/Creatives-for-Zuppa",
    category: "graphicdesign",
    stack:[<Illustrator/>,<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 59,
    title: "Kalaiyugam 2025",
    date: "Nov 2025",
    image: bc59,
    description:"Kalaiyugam 2025 is a Tamil typo challenge conducted by the Madrasters Community.",
    link: "https://www.behance.net/gallery/243287237/Kalaiyugam-2025-Tamil-Typography-Challenge",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 58,
    title: "Soul Satisfied",
    date: "Nov 2025",
    image: bc58,
    description:"Complete brand design kit for the home baking brownie studio.",
    link: "https://linktr.ee/soulsatisfied_in",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 57,
    title: "UX Audit",
    date: "Nov 2025",
    image: bc57,
    description:"UX Audit for the journey of Buying Journey and Add to cart. (Ft.Annachy App)",
    link: "https://www.behance.net/gallery/241094413/UX-Audit-ftAnnachy-App-(Ecom-App)",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 56,
    title: "Meet in the Middle",
    date: "Nov 2025",
    image: bc56,
    description:"Designed a new feature-Meet in the Mid, a Meet planner (Ft.GMap).",
    link: "https://www.behance.net/gallery/241093561/Meet-in-Mid-Feature-to-plan-casual-meetup-ftGMap",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 55,
    title: "Smartail Flyer Design",
    date: "Nov 2025",
    image: bc55,
    description:"Designed a Flyer Design for the Socail Media Engagement and Marketing.",
    link: "https://www.behance.net/gallery/243287497/Flyer-Design-for-Smartail",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 54,
    title: "Bloome Web Page",
    date: "Nov 2025",
    image: bc54,
    description:"Designed and Developed a modern, minimal landing page for Bloome Cosmetic.",
    link: "https://dhanushgopi.github.io/bloomelandingpage/",
    category: "webdev",
    stack:[<FigmaLogo/>,<Rjs/>],
    chip: <Devchip/>,
    },
    {
    id: 53,
    title: "Bloome Cosmetic UI",
    date: "Nov 2025",
    image: bc53,
    description:"Designed a modern, minimal landing page for Bloome Cosmetic.",
    link: "https://www.figma.com/design/wNn99A4mMPJoN3MEyQrQaw/Dezinersknot?node-id=0-1&t=nqM4J0nDXo0txCIA-1",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 52,
    title: "EV Station Finder",
    date: "Oct 2025",
    image: bc52,
    description:"A UX project featuring an EV charging station finder and an engaging charging UI.",
    link: "https://www.behance.net/gallery/236995335/EV-Bike-Charging-Station-Finder-and-Charging-Screen",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
     {
    id: 51,
    title: "Starry Night Pixel",
    date: "Oct 2025",
    image: bc51,
    description:"It’s a motion graphics project featuring The Starry Night in a pixelated style.",
    link: "https://www.behance.net/gallery/242561191/Starry-Night-in-Pixel",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 50,
    title: "Rethinking ATVM UX",
    date: "Sep 2025",
    image: bc50,
    description:"UI redesign of an ATVM Machine, making it easier for users to access and operate.",
    link: "https://www.behance.net/gallery/235444223/Rethinking-the-UX-of-Indian-Railways-ATVM",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 49,
    title: "CCPO System UX",
    date: "Aug 2025",
    image: bc49,
    description:"This focuses on efficiently managing a pre-order system for a campus cafeteria.",
    link: "https://www.behance.net/gallery/232126955/Campus-Cafeteria-Pre-Order-System-UX-Case-Study",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 48,
    title: "Iron Moai",
    date: "Jul 2025",
    description:"Iron Moai is inspired from the statement think like a AI by clubing the Moai and Ironman.",
    image: bc48,
    link: "https://www.behance.net/gallery/242560509/Think-Like-AI",
    category: "graphicdesign",
    stack:[<PalleteLogo/>,<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 47,
    title: "Greenbite UI",
    date: "Jun 2025",
    image: bc47,
    description:"GreenBite UI is a landing page that showcases nutrition-rich meals and balanced diet.",
    link: "https://www.behance.net/gallery/228151639/GREENBITE-UI-DESIGN",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
     {
    id: 46,
    title: "Sheildify UI",
    date: "May 2025",
    image: bc46,
    description:"Dashboard to share high-impact insights and prioritize critical task management.",
    link: "https://www.figma.com/design/CHkmomFNhhFh8rSo1VRbuH/Shieldify?node-id=2-2&t=ZL9bSDJY8XcnkpxJ-1",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 45,
    title: "Newre SaaS App",
    date: "Mar 2025",
    image: bc45,
    description:"Newre is a bus pass renewal system that simplifies the process for students.",
    link: "https://newrev2.onrender.com/",
    category: "webdev",
    stack:[<Rjs/>,<Firebase/>],
    chip: <Devchip/>,
    },
    {
    id: 44,
    title: "DPay",
    date: "Feb 2025",
    image: bc44,
    description:"DPay is a blockchain-powered NFC payment system that works without internet.",
    link: "https://nfcbc.onrender.com/",
    category: "webdev",
    stack:[<Rjs/>],
    chip: <Devchip/>,
    },
    {
    id: 43,
    title: "Universoul",
    date: "Feb 2025",
    image: bc43,
    description:"Illustrated a customized comic based on real moments from their journey.",
    link: "https://dhanushgopi.github.io/universoul/",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 42,
    title: "BounceBack",
    date: "Jan 2025",
    image: bc42,
    description:"Designed and developed the minimal landing page for the BounceBack project.",
    link: "https://bounceback.onrender.com/",
    category: "webdev",
    stack:[<Rjs/>],
    chip: <Devchip/>,
    },
    {
    id: 41,
    title: "Batman Pixart",
    date: "Dec 2024",
    image: bc41,
    description:"Inspired by the Barbie–Oppenheimer contrast, the impact of pixel art aesthetics.",
    link: "https://www.behance.net/gallery/215719723/Batman-in-Pixels",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 40,
    title: "Bounce Back UX",
    date: "Dec 2024",
    image: bc40,
    description:"BounceBack is helps to connects physiotherapists and patients in seconds.",
    link: "https://www.behance.net/gallery/235639629/BounceBack-SaaS-App-for-Physiotherapist",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 39,
    title: "DesignFest24 UI",
    date: "Dec 2024",
    image: bc39,
    description:"DesignFest’24 is a 6-day UI design challenge hosted by the CLAN Club.",
    link: "https://www.behance.net/gallery/228636333/DesignFest-2024-UX-Challenge",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
     {
    id: 38,
    title: "Flamingo",
    date: "Nov 2024",
    image: bc38,
    description:"A minimalist flamingo blending playful curves with a modern color palette.",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 37,
    title: "Design of Diwali",
    date: "Oct 2024",
    image: bc37,
    description:"A Diwali design influenced by traditional patterns from Kolam, Jalebi, and Murukku.",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 36,
    title: "Good Vibe",
    date: "Oct 2024",
    image: bc36,
    description:"A calming illustration encouraging you to always stay calm and happy.",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 35,
    title: "Lost in Mind",
    date: "Oct 2024",
    image: bc35,
    description:"A motivational illustration encouraging you to always stay in your vibe.",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 34,
    title: "Kanam App",
    date: "Sep 2024",
    image: bc34,
    description:"A app integrated with a real-time weather API and state management using Redux.",
    link: "https://dhanushgopi.github.io/kanam",
    category: "webdev",
    stack:[<Rjs/>,<Redux/>,<Mongodb/>],
    chip: <Devchip/>,
    },
    {
    id: 33,
    title: "ToDo App",
    date: "Sep 2024",
    image: bc33,
    description:"A simple and efficient to-do app built with React and MongoDB for data storage.",
    link: "https://noteapp-t2w6.onrender.com/",
    category: "webdev",
    stack:[<Rjs/>,<Mongodb/>],
    chip: <Devchip/>,
    },
    {
    id: 32,
    title: "Be You!",
    date: "Aug 2024",
    image: bc32,
    description:"A self-explanatory illustration encouraging you to be real and be yourself.",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 31,
    title: "Love Light",
    date: "Aug 2024",
    image: bc31,
    description:"An appreciation illustration for the Zero Accident Day campaign conducted by GCTP",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 30,
    title: "Sketch Book",
    date: "Aug 2024",
    image: bc30,
    description:"Designed and developed a digital sketchbook to store illustrations.",
    link: "https://dhanushgopi.github.io/sketchbook/",
    category: "webdev",
    stack:[<FigmaLogo/>,<Javascript/>],
    chip: <Devchip/>,
    },
    {
    id: 29,
    title: "Stunned Man",
    date: "Aug 2024",
    image: bc29,
    description:"Illustrated a Greek statue in a low-poly style with white shades.",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 28,
    title: "Read Automation",
    date: "Jun 2024",
    image: bc28,
    description:"A complete brand design for a robotic automation and digital agency based in Chennai.",
    link: "https://danzustudio.github.io/read.html",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 27,
    title: "Aidit",
    date: "Jun 2024",
    image: bc27,
    description:"A complete brand design for a cloud and AI technology company based in Bangalore.",
    link: "https://www.instagram.com/p/C8pFOlfveSy/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 26,
    title: "Daily Design",
    date: "Jun 2024",
    image: bc26,
    description:"A complete brand design for a digital design agency, identity and visual direction.",
    link: "https://www.instagram.com/p/C9SDZzKgSiA/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 25,
    title: "DANZU",
    date: "May 2024",
    image: bc25,
    description:"Designed and developed a high-impact landing page for a freelancing agency.",
    link: "http://danzustudio.github.io/",
    category: "webdev",
    stack:[<Illustrator/>,<FigmaLogo/>,<Javascript/>],
    chip: <Devchip/>,
    },
    {
    id: 24,
    title: "KGAS",
    date: "May 2024",
    image: bc24,
    description:"Complete brand identity design for an auto rickshaw service center.",
    link: "https://www.instagram.com/p/C6ZWoo5Pwsq/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 23,
    title: "Pastport",
    date: "Mar 2024",
    image: bc23,
    description:"It’s my Design Hackathon – Protothon 2024 submission for the “Space and Time” track.",
    link: "https://www.behance.net/gallery/212707573/pastport-UIUX-Case-Study",
    category: "uxdesign",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 22,
    title: "Poverty Logo",
    date: "Feb 2024",
    image: bc22,
    description:"It’s a logo submitted for the logo design event held in June 2K24 at GNC, Chennai.",
    link: "https://www.instagram.com/p/C55FuK4p4qJ/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 21,
    title: "Why Vanmam!",
    date: "Nov 2023",
    image: bc21,
    description:"It’s a custom English typography piece featuring a Tamil colloquial term.",
    link: "https://www.behance.net/gallery/226781883/danzu-typography",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 20,
    title: "Under Survillance",
    date: "Sep 2023",
    image: bc20,
    description:"An isometric version of Singara Chennai 2.0 featuring cyber threats.",
    link: "https://www.behance.net/gallery/226782027/Cyber-threats-of-Singara-Chennai",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 19,
    title: "Vriddhagami",
    date: "Aug 2023",
    image: bc19,
    description:"It’s a print design for the Vriddhagami initiative for the UBF (NGO).",
    link: "https://www.instagram.com/p/C55FfqWpK1q/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 18,
    title: "Rocky Website",
    date: "Jun 2023",
    image: bc18,
    description:"A fan-made landing page for the South Indian film K.G.F: Chapter 1 (2018).",
    link: "https://dhanushgopi.github.io/rocky/",
    category: "webdev",
    stack:[<Javascript/>,<FigmaLogo/>],
    chip: <Devchip/>,
    },
    {
    id: 17,
    title: "ChatGPT Challenge",
    date: "May 2023",
    image: bc17,
    description:"It is a one-week logo design challenge with a new brief each day, by ChatGPT.",
    link: "https://www.instagram.com/p/CuFV4ePBab_/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 16,
    title: "Rocky UI",
    date: "May 2023",
    image: bc16,
    description:"A fan-made UI concept for the South Indian film K.G.F: Chapter 1 (2018).",
    link: "https://www.instagram.com/p/C55FJalpwC_/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "uxdesign",
    stack:[<Illustrator/>,<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 15,
    title: "Waste Paper",
    date: "Mar 2023",
    image: bc15,
    description:"Complete brand design with YouTube cover for the channel - Waste Paper.",
    link: "https://www.instagram.com/p/C55FU5_Jvzs/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 14,
    title: "Valluverse",
    date: "Jan 2023",
    image: bc14,
    description:"Valluverse is a course platform where you can self-evaluate your pronunciation effectively.",
    link: "https://dhanushgopi.github.io/valluverse/",
    category: "webdev",
    stack:[<Illustrator/>,<FigmaLogo/>,<Javascript/>],
    chip: <Devchip/>,
    },
    {
    id: 13,
    title: "Valluverse UI",
    date: "Jan 2023",
    image: bc13,
    description:"It is the Valluverse landing page design, focusing on layout and visual direction.",
    link: "https://www.behance.net/gallery/164331693/VALLUVERSE-UI",
    category: "uxdesign",
    stack:[<Illustrator/>,<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 12,
    title: "En Nenjil!",
    date: "Dec 2022",
    image: bc12,
    description:"It’s a simple illustration of Thalapathy Vijay, inspired by Beast (2022).",
    link: "https://www.behance.net/gallery/160038337/En-Nenjil-Thalapathy-Wallpaper",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 11,
    title: "Tears Poster",
    date: "Dec 2022",
    image: bc11,
    description:"This is a vector photo manipulation poster of a modern Humpty Dumpty.",
    link: "https://www.behance.net/gallery/158514259/TEARS-POSTER-VIBECTORS",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 10,
    title: "Steal from Artist",
    date: "Nov 2022",
    image: bc10,
    description:"I created these line art vectors inspired by the Instagram artist @ycapkinn_art.",
    link: "https://www.behance.net/gallery/158220541/Line-Art-Vibectors-Inspired-from-ig-ycapkinn_art",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 9,
    title: "Chetaa Chai",
    date: "Aug 2022",
    image: bc9,
    description:"This is my submission based on a logo design brief shared by the Fake Clients site.",
    link: "https://www.behance.net/gallery/149783033/Chetaa-Chai-logo-Fake-Clients",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 8,
    title: "Astro Bites",
    date: "Jul 2022",
    image: bc8,
    description:"A modern landing page for our “Namma Oru Product – Thean Mittai.”",
    link: "https://www.behance.net/gallery/148073953/Thean-Mittai-(Honey-Candy)-Nostalgic-UI-Design",
    category: "uxdesign",
    stack:[<FigmaLogo/>,<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 7,
    title: "CalTask",
    date: "Jul 2022",
    image: bc7,
    description:"This is my submission for the logo design challenge by DAF Designs.",
    link: "https://www.behance.net/gallery/148065727/CalTask-Logo-Design-Challenge-by-Daf-Designs",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id:6,
    title: "Lykka Naturals",
    date: "Jul 2022",
    image: bc6,
    description:"It’s a brand design for a Europe-based cosmetic brand named Lykka Naturals.",
    link: "https://www.instagram.com/p/C55EybWp9gL/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    category: "branddesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 5,
    title: "Politics is a Business",
    date: "Jun 2022",
    image: bc5,
    description:"Created for an inter-college poster competition on Flying Technology.",
    link: "https://www.behance.net/gallery/147179729/Concept-Art",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 4,
    title: "Digital Portrait",
    date: "Jun 2022",
    image: bc4,
    description:"Illustrated a digital vector self-portrait as a personal project in adobe illustrator.",
    link: "https://www.behance.net/gallery/226781707/Vector-Portraits",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 3,
    title: "Beast TShirt Design",
    date: "Mar 2022",
    image: bc3,
    description:"Created 10+ custom T-shirt print designs for ICustomyzo, inspired by the Beast movie.",
    link: "https://www.behance.net/gallery/147178931/T-shirt-Design-for-ICustoMyzo-BEAST",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 2,
    title: "Carousel Poster",
    date: "Feb 2022",
    image: bc2,
    description:"Created carousel posters to improve engagement for ABN Junction Pvt Ltd’s social media.",
    link: "https://drive.google.com/file/d/1NZTJIjiPYuFAfXYUXvgBpwzvspaERn_B/view?usp=sharing",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
     id: 1,
    title: "Festivities Poster",
    date: "Feb 2022",
    image: bc1,
    description:"Designed festive posters for ABN Junction Pvt Ltd’s social media platforms.",
    link: "https://drive.google.com/file/d/1NZTJIjiPYuFAfXYUXvgBpwzvspaERn_B/view?usp=sharing",
    category: "graphicdesign",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    //Best works
    {
    id: 60,
    title: "Creatives for Zuppa",
    date: "Jan 2026",
    image: bc60,
    description:"Creatives for Zuppa - Task is to create various poster for the Social Media and Mobile UI.",
    link: "https://www.behance.net/gallery/243791711/Creatives-for-Zuppa",
    category: "bestworks",
    stack:[<Illustrator/>,<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 58,
    title: "Soul Satisfied",
    date: "Nov 2025",
    image: bc58,
    description:"Complete brand design kit for the home baking brownie studio.",
    link: "https://linktr.ee/soulsatisfied_in",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 57,
    title: "UX Audit",
    date: "Nov 2025",
    image: bc57,
    description:"UX Audit for the journey of Buying Journey and Add to cart. (Ft.Annachy App)",
    link: "https://www.behance.net/gallery/241094413/UX-Audit-ftAnnachy-App-(Ecom-App)",
    category: "bestworks",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 56,
    title: "Meet in the Middle",
    date: "Nov 2025",
    image: bc56,
    description:"Designed a new feature-Meet in the Mid, a Meet planner (Ft.GMap).",
    link: "https://www.behance.net/gallery/241093561/Meet-in-Mid-Feature-to-plan-casual-meetup-ftGMap",
    category: "bestworks",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 55,
    title: "Smartail Flyer Design",
    date: "Nov 2025",
    image: bc55,
    description:"Designed a Flyer Design for the Socail Media Engagement and Marketing.",
    link: "https://www.behance.net/gallery/243287497/Flyer-Design-for-Smartail",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 54,
    title: "Bloome Web Page",
    date: "Nov 2025",
    image: bc54,
    description:"Designed and Developed a modern, minimal landing page for Bloome Cosmetic.",
    link: "https://dhanushgopi.github.io/bloomelandingpage/",
    category: "bestworks",
    stack:[<FigmaLogo/>,<Rjs/>],
    chip: <Devchip/>,
    },
    {
    id: 53,
    title: "Bloome Cosmetic UI",
    date: "Nov 2025",
    image: bc53,
    description:"Designed a modern, minimal landing page for Bloome Cosmetic.",
    link: "https://www.figma.com/design/wNn99A4mMPJoN3MEyQrQaw/Dezinersknot?node-id=0-1&t=nqM4J0nDXo0txCIA-1",
    category: "bestworks",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 52,
    title: "EV Station Finder",
    date: "Oct 2025",
    image: bc52,
    description:"A UX project featuring an EV charging station finder and an engaging charging UI.",
    link: "https://www.behance.net/gallery/236995335/EV-Bike-Charging-Station-Finder-and-Charging-Screen",
    category: "bestworks",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 50,
    title: "Rethinking ATVM UX",
    date: "Sep 2025",
    image: bc50,
    description:"UI redesign of an ATVM Machine, making it easier for users to access and operate.",
    link: "https://www.behance.net/gallery/235444223/Rethinking-the-UX-of-Indian-Railways-ATVM",
    category: "bestworks",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 47,
    title: "Greenbite UI",
    date: "Jun 2025",
    image: bc47,
    description:"GreenBite UI is a landing page that showcases nutrition-rich meals and balanced diet.",
    link: "https://www.behance.net/gallery/228151639/GREENBITE-UI-DESIGN",
    category: "bestworks",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
     {
    id: 46,
    title: "Sheildify UI",
    date: "May 2025",
    image: bc46,
    description:"Dashboard to share high-impact insights and prioritize critical task management.",
    link: "https://www.figma.com/design/CHkmomFNhhFh8rSo1VRbuH/Shieldify?node-id=2-2&t=ZL9bSDJY8XcnkpxJ-1",
    category: "bestworks",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 45,
    title: "Newre SaaS App",
    date: "Mar 2025",
    image: bc45,
    description:"Newre is a bus pass renewal system that simplifies the process for students.",
    link: "https://newrev2.onrender.com/",
    category: "bestworks",
    stack:[<Rjs/>,<Firebase/>],
    chip: <Devchip/>,
    },
    {
    id: 44,
    title: "DPay",
    date: "Feb 2025",
    image: bc44,
    description:"DPay is a blockchain-powered NFC payment system that works without internet.",
    link: "https://nfcbc.onrender.com/",
    category: "bestworks",
    stack:[<Rjs/>],
    chip: <Devchip/>,
    },
    {
    id: 43,
    title: "Universoul",
    date: "Feb 2025",
    image: bc43,
    description:"Illustrated a customized comic based on real moments from their journey.",
    link: "https://dhanushgopi.github.io/universoul/",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 42,
    title: "BounceBack Website",
    date: "Jan 2025",
    image: bc42,
    description:"Designed and developed the minimal landing page for the BounceBack project.",
    link: "https://bounceback.onrender.com/",
    category: "bestworks",
    stack:[<Rjs/>],
    chip: <Devchip/>,
    },
    {
    id: 41,
    title: "Batman Pixart",
    date: "Dec 2024",
    image: bc41,
    description:"Inspired by the Barbie–Oppenheimer contrast, the impact of pixel art aesthetics.",
    link: "https://www.behance.net/gallery/215719723/Batman-in-Pixels",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 40,
    title: "Bounce Back UX",
    date: "Dec 2024",
    image: bc40,
    description:"BounceBack is helps to connects physiotherapists and patients in seconds.",
    link: "https://www.behance.net/gallery/235639629/BounceBack-SaaS-App-for-Physiotherapist",
    category: "bestworks",
    stack:[<FigmaLogo/>],
    chip: <Designchip/>,
    },
    {
    id: 38,
    title: "Flamingo",
    date: "Nov 2024",
    image: bc38,
    description:"A minimalist flamingo blending playful curves with a modern color palette.",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
     {
    id: 37,
    title: "Design of Diwali",
    date: "Oct 2024",
    image: bc37,
    description:"A Diwali design influenced by traditional patterns from Kolam, Jalebi, and Murukku.",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 34,
    title: "Kanam App",
    date: "Sep 2024",
    image: bc34,
    description:"A app integrated with a real-time weather API and state management using Redux.",
    link: "https://dhanushgopi.github.io/kanam",
    category: "bestworks",
    stack:[<Rjs/>,<Redux/>,<Mongodb/>],
    chip: <Devchip/>,
    },
    {
    id: 32,
    title: "Be You!",
    date: "Aug 2024",
    image: bc32,
    description:"A self-explanatory illustration encouraging you to be real and be yourself.",
    link: "https://www.behance.net/gallery/210090565/Just-Draw",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 28,
    title: "Read Automation",
    date: "Jun 2024",
    image: bc28,
    description:"A complete brand design for a robotic automation and digital agency based in Chennai.",
    link: "https://danzustudio.github.io/read.html",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 25,
    title: "DANZU",
    date: "May 2024",
    image: bc25,
    description:"Designed and developed a high-impact landing page for a freelancing agency.",
    link: "http://danzustudio.github.io/",
    category: "bestworks",
    stack:[<Illustrator/>,<FigmaLogo/>,<Javascript/>],
    chip: <Devchip/>,
    },
    {
    id: 24,
    title: "KGAS",
    date: "May 2024",
    image: bc24,
    description:"Complete brand identity design for an auto rickshaw service center.",
    link: "https://www.behance.net/gallery/197489731/Karthick-Gopi-Auto-Service-Brand-Design",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 14,
    title: "Valluverse",
    date: "Jan 2023",
    image: bc14,
    description:"Valluverse is a course platform where you can self-evaluate your pronunciation effectively.",
    link: "https://dhanushgopi.github.io/valluverse/",
    category: "bestworks",
    stack:[<Illustrator/>,<FigmaLogo/>,<Javascript/>],
    chip: <Devchip/>,
    },
    {
    id: 11,
    title: "Tears Poster",
    date: "Dec 2022",
    image: bc11,
    description:"This is a vector photo manipulation poster of a modern Humpty Dumpty.",
    link: "https://www.behance.net/gallery/158514259/TEARS-POSTER-VIBECTORS",
   category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    },
    {
    id: 10,
    title: "Steal from Artist",
    date: "Nov 2022",
    image: bc10,
    description:"I created these line art vectors inspired by the Instagram artist @ycapkinn_art.",
    link: "https://www.behance.net/gallery/158220541/Line-Art-Vibectors-Inspired-from-ig-ycapkinn_art",
    category: "bestworks",
    stack:[<Illustrator/>],
    chip: <Designchip/>,
    }

];

export default portfolioData;